export const textWithClickableLink = (htmlContent) => {
    const urlRegex = /https?:\/\/\S+?(?=<br>|$|\s)/g;
    const contentWithLinks = htmlContent.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
    return contentWithLinks;
  };